import { render, staticRenderFns } from "./medicine-order-details-watsons-pickup.vue?vue&type=template&id=e0cc5c74"
import script from "./medicine-order-details-watsons-pickup.vue?vue&type=script&lang=js"
export * from "./medicine-order-details-watsons-pickup.vue?vue&type=script&lang=js"
import style0 from "./medicine-order-details-watsons-pickup.vue?vue&type=style&index=0&id=e0cc5c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports